import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { subscribeToBlogWidgetStyles as styles } from "@solveindustrial/Widgets/VerndaleBox/SubscribeToBlogWidget";
import { css } from "styled-components";

styles.titleLabel = {
    weight: 700,
    size: "18px",
    lineHeight: "24px",
};

styles.emailTextField = {
    css: css`
        min-height: 50px;

        ${mediaQueriesBP.maxMD} {
            min-height: 30px;
        }
    `,
};

styles.emailButton = {
    mergeCss: true,
    css: css`
        min-height: 50px;
        width: 100%;

        ${mediaQueriesBP.maxMD} {
            min-height: 40px;
        }
    `,
};
